/* Reef Lagoon — shared scroll-reveal utility.
 * Reveals elements carrying .rv by adding .in on first intersection; per-element
 * stagger comes from an inline --d custom property consumed by the CSS transition.
 * Reduced-motion and no-IntersectionObserver fall straight to the final state.
 * Idempotent (elements are armed once, guarded by data-rv-armed); re-inits on the
 * theme editor's shopify:section:load. transform/opacity only.
 * First consumer: the Our Story page (reef-story-* sections). */
(function () {
  'use strict';
  if (window.__reefRevealLoaded) return; // section files each include this script
  window.__reefRevealLoaded = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function arm(scope) {
    var els = (scope || document).querySelectorAll('.rv:not([data-rv-armed])');
    if (!els.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.setAttribute('data-rv-armed', '1');
        el.classList.add('in');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-rv-armed', '1');
      io.observe(el);
    });
  }

  function initAll() { arm(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });

  window.ReefReveal = window.ReefReveal || { arm: arm };
})();
